export default "__VITE_ASSET__DuBE1kk0__"